import React from 'react';
import Skeleton from 'react-loading-skeleton';

import * as S from './styles';

const SkeletonLoading: React.FC = () => {
  return (
    <>
      <S.AdSenseCredentialWrapper>
        <S.IdWrapper>
          <Skeleton width="100%" height={20} />
        </S.IdWrapper>
        <S.NameWrapper>
          <Skeleton width="100%" height={16} />
        </S.NameWrapper>
      </S.AdSenseCredentialWrapper>

      <S.AdSenseCredentialWrapper>
        <S.IdWrapper>
          <Skeleton width="100%" height={20} />
        </S.IdWrapper>
        <S.NameWrapper>
          <Skeleton width="100%" height={16} />
        </S.NameWrapper>
      </S.AdSenseCredentialWrapper>

      <S.AdSenseCredentialWrapper>
        <S.IdWrapper>
          <Skeleton width="100%" height={20} />
        </S.IdWrapper>
        <S.NameWrapper>
          <Skeleton width="100%" height={16} />
        </S.NameWrapper>
      </S.AdSenseCredentialWrapper>
    </>
  );
};

export default SkeletonLoading;
